import React from "react";
import { Link, useLocation } from "react-router-dom";

import { Alert, Button } from "antd";
import qs from "qs";

import "./style/auth.scoped.scss";

const AuthError = () => {
    const location = useLocation();
    const { error } = qs.parse(location.search, { ignoreQueryPrefix: true });

    return (
        <div className="auth-error auth">
            <div className="logo">
                <img src={require("@app/assets/logo-name.svg")} />
            </div>

            <Alert
                className="alert"
                message="Authentication Failed"
                description={error || "Access denied"}
                type="error"
                showIcon
            />

            <Link to="/auth/login">
                <Button type="primary" size="large">
                    Back to Sign In
                </Button>
            </Link>
        </div>
    );
};

export default AuthError;
